import Store from '@/store';
import SisDkpClienteClient from '@/api/sis-dkp-cliente.client';
import Notifier from '@/libs/Notifier';

export default class SisDkpClientesService {
  constructor() {
    this.client = new SisDkpClienteClient();
    this.store = Store;
    this.notify = new Notifier();
  }

  async findAll() {
    try {
      const { data, ...pagination } = await this.client.getDkpClientes(this.store.getters['slsFamiliaComercial/getFilters']);
      this.store.commit('sisDkpClientes/SET_DKP_CLIENTES_ALL', data);
      this.store.commit('sisDkpClientes/SET_FILTERS', pagination);
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }

  async create(body) {
    console.log(body);
    try {
      await this.client.postDkpClientes(body);
      this.notify.success('Cliente criado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }

  async delete(id) {
    try {
      await this.client.deleteDkpClientesIdSoftDelete(id);
      this.notify.success('Cliente deletado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }

  async edit(id, body) {
    try {
      const { message } = await this.client.putDkpClientesId(id, body);
      this.notify.success(message);
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }
}
